var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInfoIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1731_70193)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.01367 6.98016C7.01367 6.80343 7.15694 6.66016 7.33367 6.66016H8.00034C8.17707 6.66016 8.32034 6.80343 8.32034 6.98016V10.8552C8.32034 11.0319 8.17707 11.1752 8.00034 11.1752C7.82361 11.1752 7.68034 11.0319 7.68034 10.8552V7.30016H7.33367C7.15694 7.30016 7.01367 7.15689 7.01367 6.98016Z",
  fill: "#08081B"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.01367 10.9802C7.01367 10.8034 7.15694 10.6602 7.33367 10.6602H8.667C8.84374 10.6602 8.987 10.8034 8.987 10.9802C8.987 11.1569 8.84374 11.3002 8.667 11.3002H7.33367C7.15694 11.3002 7.01367 11.1569 7.01367 10.9802Z",
  fill: "#08081B"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.83302 5.30016C7.96373 5.30016 8.06969 5.1942 8.06969 5.06349C8.06969 4.93278 7.96373 4.82682 7.83302 4.82682C7.70231 4.82682 7.59635 4.93278 7.59635 5.06349C7.59635 5.1942 7.70231 5.30016 7.83302 5.30016ZM7.42969 5.06349C7.42969 4.84074 7.61026 4.66016 7.83302 4.66016C8.05578 4.66016 8.23635 4.84074 8.23635 5.06349C8.23635 5.28624 8.05578 5.46682 7.83302 5.46682C7.61026 5.46682 7.42969 5.28624 7.42969 5.06349Z",
  fill: "#08081B"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.9795 2.00719C6.38467 2.00719 4.85515 2.64073 3.72744 3.76845C2.59972 4.89617 1.96617 6.42569 1.96617 8.02052C1.96617 9.61536 2.59972 11.1449 3.72744 12.2726C4.85515 13.4003 6.38467 14.0339 7.9795 14.0339C9.57434 14.0339 11.1039 13.4003 12.2316 12.2726C13.3593 11.1449 13.9928 9.61536 13.9928 8.02052C13.9928 6.42569 13.3593 4.89617 12.2316 3.76845C11.1039 2.64073 9.57434 2.00719 7.9795 2.00719ZM3.27489 3.3159C4.52263 2.06816 6.21493 1.36719 7.9795 1.36719C9.74408 1.36719 11.4364 2.06816 12.6841 3.3159C13.9319 4.56365 14.6328 6.25595 14.6328 8.02052C14.6328 9.7851 13.9319 11.4774 12.6841 12.7251C11.4364 13.9729 9.74408 14.6739 7.9795 14.6739C6.21493 14.6739 4.52263 13.9729 3.27489 12.7251C2.02715 11.4774 1.32617 9.7851 1.32617 8.02052C1.32617 6.25595 2.02715 4.56365 3.27489 3.3159Z",
  fill: "#08081B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.83297 5.47844C8.06217 5.47844 8.24797 5.29264 8.24797 5.06344C8.24797 4.83424 8.06217 4.64844 7.83297 4.64844C7.60377 4.64844 7.41797 4.83424 7.41797 5.06344C7.41797 5.29264 7.60377 5.47844 7.83297 5.47844Z",
  fill: "#08081B"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1731_70193"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "#08081B"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgInfoIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/info-icon.8c93c135d44d5ba9cd51561cfcc6d078.svg";